import { DataFileInterface } from '@systemeio/file-manager'
import { CustomDomainsStatusEnum } from 'modules/profile/custom-domains-settings/enums/custom-domains-settings-enum'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'

export interface CustomDomainsSettingsApiInterface
  extends DataWithPaginationInterface<CustomDomainsSettingsInterface> {}

export type CustomDomainsSettingId = number

export enum DomainLabelTypeEnum {
  SystemeIo = 'SystemeIo',
  WhiteLabel = 'WhiteLabel',
}

export interface CustomDomainsSettingsInterface {
  id: CustomDomainsSettingId
  status: CustomDomainsStatusEnum
  faviconFile: {
    filename: string
    id: number
    path: string
  } | null
  logoFile: {
    filename: string
    id: number
    path: string
  } | null
  loginPage: { id: number; path: string | null } | null
  notFoundPage: { id: number; path: string | null } | null
  domainName: string
  emailForSupport: string | null
  facebookConversionPixelSettings: { pixel: string; token: string } | null
  seo: {
    fbAppId: string
  } | null
  domainCaptchaSettings: { openKey: string; privateKey: string } | null
  dnsSettings: Record<string, string> | null
  defaultDomain: boolean
  homePageEditUrl: string | null
  type: 'sio_subdomain' | 'aws'
  labelType: DomainLabelTypeEnum
}

export interface CustomDomainsCreateInterface {
  domainName: string
}

export interface CustomDomainsEditInterface {
  emailForSupport: string | null
  facebookConversionPixelSettings: NonNullable<
    CustomDomainsSettingsInterface['facebookConversionPixelSettings']
  >
  seo: { fbAppId: string }
  domainCaptchaSettings: NonNullable<CustomDomainsSettingsInterface['domainCaptchaSettings']>
  faviconFile?: Pick<DataFileInterface, 'filename' | 'id' | 'path'> | null
  logoFile?: Pick<DataFileInterface, 'filename' | 'id' | 'path'> | null
}

export interface CustomDomainsEditRequestPayloadInterface
  extends Pick<
    CustomDomainsEditInterface,
    'facebookConversionPixelSettings' | 'domainCaptchaSettings'
  > {
  faviconFile?: number | null
  logoFile?: number | null
}

export interface CustomDomainsEditErrorsInterface {
  faviconFile: string
  logoFile: string
  facebookConversionPixelSettings: Record<
    keyof CustomDomainsEditInterface['facebookConversionPixelSettings'],
    string
  >
  seo: Record<keyof CustomDomainsEditInterface['seo'], string>
  domainCaptchaSettings: Record<keyof CustomDomainsEditInterface['domainCaptchaSettings'], string>
  common: string
  emailForSupport: string
}

export interface CustomDomainsSubdomainEditInterface {
  name: string
}

export interface CustomDomainsLoginPageApiInterface {
  loginPageUrl: string
}
